import { render, staticRenderFns } from "./DebtTable.vue?vue&type=template&id=5bbef98a&"
import script from "./DebtTable.vue?vue&type=script&lang=js&"
export * from "./DebtTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports